// extracted by mini-css-extract-plugin
export default {"mainContent":"auth-page-template_mainContent__UTPuO","headerIcon":"auth-page-template_headerIcon__2A+oj","pageHeader":"auth-page-template_pageHeader__Fa+sS"};